import { UAParser } from 'ua-parser-js';

export function isAndroid(): boolean {
  return new UAParser().getOS().name === 'Android';
}

export function isIOS(): boolean {
  const os = new UAParser().getOS().name;
  return (
    os === 'iOS' ||
    // For the iPad's "Request Desktop Website" setting
    (os === 'Mac OS' && (window.navigator as any).standalone !== undefined)
  );
}

export function isMobile(): boolean {
  return isAndroid() || isIOS();
}

export function isHTMLLinkElement(what: any): what is HTMLLinkElement {
  return what && what.href;
}
